import { createContext } from 'react';

const Contextapi = createContext();

export default Contextapi;
